import { render } from "./pageOverlay.vue?vue&type=template&id=36a7dafe"
import script from "./pageOverlay.vue?vue&type=script&lang=js"
export * from "./pageOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__